'use client';

export default function LocationSection() {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1327.373358500574!2d28.830128390256473!3d47.01920694370899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40c97c2e1aaa6fdf%3A0xfd8f22f16e3ddcc7!2sTibetmed!5e1!3m2!1sru!2sru!4v1709507893374!5m2!1sru!2sru"
      width="100%"
      height="100%"
      style={{ border: 0, width: '100%', height: '500px' }}
      allowFullScreen
      loading="lazy"
    />
  );
}
